export default __webpack_public_path__ + "static/media/google-play.87c90363.png";